import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoginService } from '../login/login.service';

// import { AuthenticationService } from '../_services';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private handlingUnauthorized = false;
  constructor(
    private authenticationService: LoginService,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        if (err.status === 400) {
        }
        if (err.status === 401) {
          // Auto logout if a 401 response is returned from API and a session exists.
          if (
            this.authenticationService.hasActiveSession() &&
            !this.handlingUnauthorized
          ) {
            this.handlingUnauthorized = true;
            this.authenticationService.logout();
            localStorage.setItem('logOut', '1');
            this.router
              .navigate(['/login'])
              .then(() => {
                this.handlingUnauthorized = false;
              })
              .catch(() => {
                this.handlingUnauthorized = false;
              });
          }
        }
        if (err.status >= 500) {
          this.router.navigate(['serviceDown']);
        }

        return throwError(err);
      })
    );
  }
}
